import { ComponentType } from 'react';
import { DefaultInlineErrorFallback, CompactInlineErrorFallback, MicroInlineErrorFallback } from '@v2/components/errorBoundary/InlineErrorFallback';
import { InlineErrorFallbackSize } from '@v2/components/errorBoundary/types';
import type { ErrorFallbackProps } from '@v2/components/errorBoundary/types';

// Lookup table mapping an InlineErrorBoundary size to the fallback that renders it.
export const SIZE_FALLBACKS: Record<InlineErrorFallbackSize, ComponentType<ErrorFallbackProps>> = {
  [InlineErrorFallbackSize.Full]: DefaultInlineErrorFallback,
  [InlineErrorFallbackSize.Compact]: CompactInlineErrorFallback,
  [InlineErrorFallbackSize.Micro]: MicroInlineErrorFallback,
};
